export default __webpack_public_path__ + "static/media/investment.3d0808d5.png";